// extracted by mini-css-extract-plugin
export default {"createTicketButton":"default_createTicketButton__f4aiZ","createTicketButtonIcon":"default_createTicketButtonIcon__cMzxI"};